import { IonLabel } from "@ionic/react";
import { useTranslation } from "react-i18next";

const NoDataFound: React.FC = () => {
	const { t } = useTranslation();

	return (
		<IonLabel
			color="medium"
			style={{
				fontSize: 14,
				fontWeight: 400,
				marginLeft: 20,
				marginTop: 20
			}}
		>
			{t("noDataFound")}
		</IonLabel>
	);
};

export default NoDataFound;
